module.exports = __webpack_public_path__ + "media/images/products/tv-desktop-6d91667944d86365067372482bcce5ab.png";